import { cn } from '@/shared/lib/utils';

/**
 * Ikony tree-view portované 1:1 z design handoffu „Anatomie tree-view" (PHX-TREE-01).
 * Na rozdíl od PHX_ICONS (24×24) jsou kreslené na 12px mřížce s vlastními tahy,
 * proto žijí jako samostatné komponenty. Signatura `{ className?: string }`
 * odpovídá `TreeNodeType.icon`, velikost je u každé ikony pevně daná návrhem.
 */

interface TreeIconProps {
  className?: string;
}

interface TreeSvgProps extends TreeIconProps {
  size: number;
  strokeWidth: number;
  children: React.ReactNode;
}

function TreeSvg({ size, strokeWidth, className, children }: TreeSvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn('shrink-0', className)}
    >
      {children}
    </svg>
  );
}

/** Chevron rozbalení uzlu (interní pro TreeView). */
export function TreeChevronIcon({ className }: TreeIconProps) {
  return (
    <TreeSvg size={11} strokeWidth={1.6} className={className}>
      <path d="M4.5 2.5 8 6l-3.5 3.5" />
    </TreeSvg>
  );
}

/** Trychtýř štítku částečné shody (interní pro TreeView). */
export function TreeFunnelIcon({ className }: TreeIconProps) {
  return (
    <TreeSvg size={9} strokeWidth={1.6} className={className}>
      <path d="M1.5 2h9L7 6.5V10L5 8.5V6.5z" />
    </TreeSvg>
  );
}

/** Složka — 1. úroveň (Strom produktů: destinace/sezóna). */
export function TreeFolderIcon({ className }: TreeIconProps) {
  return (
    <TreeSvg size={13} strokeWidth={1.3} className={className}>
      <path d="M1.5 3.5v6h9v-5h-4.7l-1-1.5H1.5z" />
    </TreeSvg>
  );
}

/** Krabice — 2. úroveň (produkt). */
export function TreeBoxIcon({ className }: TreeIconProps) {
  return (
    <TreeSvg size={12} strokeWidth={1.3} className={className}>
      <path d="M6 1.5 10.5 3.8v4.4L6 10.5 1.5 8.2V3.8z" />
      <path d="M1.5 3.8 6 6l4.5-2.2" />
      <path d="M6 6v4.5" />
    </TreeSvg>
  );
}

/** Článek řetězu — 3. úroveň (série). */
export function TreeChainIcon({ className }: TreeIconProps) {
  return (
    <TreeSvg size={12} strokeWidth={1.3} className={className}>
      <path d="M6.8 3.4l1-1a2.05 2.05 0 0 1 2.9 2.9l-1 1" />
      <path d="M5.2 8.6l-1 1a2.05 2.05 0 0 1-2.9-2.9l1-1" />
      <path d="M4.6 7.4l2.8-2.8" />
    </TreeSvg>
  );
}

/** Osoby — 4. úroveň (termín). */
export function TreeUsersIcon({ className }: TreeIconProps) {
  return (
    <TreeSvg size={12} strokeWidth={1.3} className={className}>
      <circle cx="4.5" cy="4" r="1.8" />
      <path d="M1.5 10c0-1.7 1.3-3 3-3s3 1.3 3 3" />
      <path d="M8 4.4c.8.2 1.4 1 1.4 1.9M8.8 7.4c1 .4 1.7 1.4 1.7 2.6" />
    </TreeSvg>
  );
}
